function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevicesLockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 617 338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 614.5,
    height: 335.5,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 614.5,
    height: 335.5,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 1.5,
    width: 541,
    height: 335,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,1.5H62a3,3,0,0,0-3,3v287a3,3,0,0,0,3,3H597a3,3,0,0,0,3-3V4.5A3,3,0,0,0,597,1.5Z",
    style: {
      fill: "#e6eaed",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5,128a22.11,22.11,0,0,0-18.3,10,22.13,22.13,0,0,0-18.3-10,21.79,21.79,0,0,0-15.48,6.47A22.21,22.21,0,0,0,289,150.1c0,7.75,4.86,13.34,9.94,18.5l19.85,19a1.61,1.61,0,0,0,1.78.31,1.66,1.66,0,0,0,1-1.53V171.59a7.66,7.66,0,1,1,15.31,0v14.74a1.63,1.63,0,0,0,2.75,1.2l19.85-18.93c5.08-5.16,9.94-10.75,9.94-18.5A22.21,22.21,0,0,0,363,134.47,21.79,21.79,0,0,0,347.5,128ZM309,167.09a1.44,1.44,0,0,1-2.07.13c-6.34-5.76-9.55-11.77-9.55-17.87v-.07c0-5.24,3.12-11.21,7.25-13.87a1.46,1.46,0,0,1,2,.5,1.53,1.53,0,0,1-.45,2.06c-3.29,2.13-5.87,7.1-5.87,11.31v.07c0,5.19,2.88,10.45,8.56,15.6a1.56,1.56,0,0,1,.5,1A1.51,1.51,0,0,1,309,167.09Zm9.79-5.09a1.51,1.51,0,0,1-1.32.8,1.49,1.49,0,0,1-.71-.2,14.93,14.93,0,0,1-7.38-12.43v-.07A12.63,12.63,0,0,1,315.85,139a1.46,1.46,0,0,1,1.51.06,1.59,1.59,0,0,1-.09,2.7,9.5,9.5,0,0,0-4.89,8.38,11.75,11.75,0,0,0,5.85,9.77,1.52,1.52,0,0,1,.71.93A1.61,1.61,0,0,1,318.81,162Zm10.39-4a6.6,6.6,0,1,1,6.6-6.6A6.6,6.6,0,0,1,329.2,158Zm12.42,4.6a1.46,1.46,0,0,1-2.17-1,1.56,1.56,0,0,1,.76-1.75,11.79,11.79,0,0,0,5.77-9.75,9.49,9.49,0,0,0-4.9-8.37,1.6,1.6,0,0,1-.62-2.12,1.49,1.49,0,0,1,2-.65A12.65,12.65,0,0,1,349,150.1v.05a15.05,15.05,0,0,1-7.38,12.48ZM361,149.34c0,6.1-3.22,12.12-9.56,17.88a1.44,1.44,0,0,1-2.34-.6,1.54,1.54,0,0,1,.39-1.66c5.68-5.16,8.57-10.42,8.57-15.61v-.07c0-4.22-2.58-9.22-5.88-11.3a1.54,1.54,0,0,1-.44-2.07,1.45,1.45,0,0,1,2-.5c4.15,2.66,7.26,8.63,7.26,13.87Z",
    style: {
      fill: "#c6002b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 294.5,
    width: 157,
    height: 42,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,294.5H295a3,3,0,0,0-3,3v36a3,3,0,0,0,3,3h69a3,3,0,0,0,3-3v-36A3,3,0,0,0,364,294.5Z",
    style: {
      fill: "#e6eaed",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,329.5H254a3,3,0,0,0-3,3v1a3,3,0,0,0,3,3H405a3,3,0,0,0,3-3v-1A3,3,0,0,0,405,329.5Z",
    style: {
      fill: "#e6eaed",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 71.5,
    width: 167,
    height: 265,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.5,71.5h-127a20,20,0,0,0-20,20v225a20,20,0,0,0,20,20h127a20,20,0,0,0,20-20V91.5A20,20,0,0,0,595.5,71.5Z",
    style: {
      fill: "#e6eaed",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474,
    y: 202,
    width: 117,
    height: 117,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.5,319A58.5,58.5,0,1,0,474,260.5,58.5,58.5,0,0,0,532.5,319Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,285a24,24,0,1,0-24-24A24,24,0,0,0,533,285Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,285a24,24,0,1,0-24-24A24,24,0,0,0,533,285Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 115,
    width: 48,
    height: 48,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,163a24,24,0,1,0-24-24A24,24,0,0,0,533,163Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,149a10,10,0,1,0-10-10A10,10,0,0,0,533,149Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 70.5,
    width: 189.01,
    height: 266,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5,70.5H48.5a16,16,0,0,0-16,16v234a16,16,0,0,0,16,16h157a16,16,0,0,0,16-16V86.5A16,16,0,0,0,205.5,70.5Z",
    style: {
      fill: "#e6eaed",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,184a14.75,14.75,0,0,0-12.2,6.66A14.75,14.75,0,0,0,114.6,184a14.52,14.52,0,0,0-10.32,4.31A14.83,14.83,0,0,0,100,198.74c0,5.16,3.24,8.89,6.62,12.33l13.24,12.63a1.09,1.09,0,0,0,1.18.21,1.12,1.12,0,0,0,.66-1v-9.83a5.1,5.1,0,1,1,10.2,0v9.83a1.11,1.11,0,0,0,.66,1,1.09,1.09,0,0,0,1.18-.21L147,211.07c3.38-3.44,6.62-7.17,6.62-12.33a14.83,14.83,0,0,0-4.28-10.43A14.52,14.52,0,0,0,139,184Zm-25.65,26.06a1,1,0,0,1-.74.34,1,1,0,0,1-.65-.25c-4.22-3.84-6.36-7.85-6.36-11.92v0a11.81,11.81,0,0,1,4.83-9.24,1,1,0,0,1,1.34.33,1,1,0,0,1-.29,1.38,9.76,9.76,0,0,0-3.92,7.53v0c0,3.47,1.92,7,5.7,10.4a1,1,0,0,1,.34.7A1.06,1.06,0,0,1,113.35,210.06Zm6.52-3.39a1,1,0,0,1-.88.53,1,1,0,0,1-.47-.13,10,10,0,0,1-4.92-8.29v-.05a8.42,8.42,0,0,1,4.3-7.41,1,1,0,0,1,1,0,1.07,1.07,0,0,1,.47.92,1,1,0,0,1-.53.88,6.31,6.31,0,0,0-3.26,5.59,7.83,7.83,0,0,0,3.9,6.51,1,1,0,0,1,.47.62A1,1,0,0,1,119.87,206.67ZM126.8,204a4.4,4.4,0,1,1,4.4-4.4A4.4,4.4,0,0,1,126.8,204Zm8.28,3.07a1,1,0,0,1-1.45-.66,1.06,1.06,0,0,1,.51-1.17,7.85,7.85,0,0,0,3.85-6.49,6.34,6.34,0,0,0-3.27-5.59,1.06,1.06,0,0,1-.42-1.41,1,1,0,0,1,1.36-.43,8.44,8.44,0,0,1,4.34,7.41v0a10,10,0,0,1-4.92,8.32ZM148,198.23c0,4.06-2.15,8.07-6.37,11.92a1,1,0,0,1-.65.25,1,1,0,0,1-.92-.65,1,1,0,0,1,.27-1.11c3.79-3.44,5.71-6.95,5.71-10.4v-.05a9.72,9.72,0,0,0-3.92-7.54,1,1,0,0,1-.3-1.38,1,1,0,0,1,1.34-.33,11.78,11.78,0,0,1,4.84,9.25Z",
    style: {
      fill: "#c6002b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,82a3,3,0,1,0-3-3A3,3,0,0,0,127,82Z",
    style: {
      fill: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,87.5h189",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeLinecap: "square",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,310.5h189",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeLinecap: "square",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 123,
    width: 112,
    height: 214,
    style: {
      fill: "#181818",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,123H17A16,16,0,0,0,1,139V321a16,16,0,0,0,16,16H97a16,16,0,0,0,16-16V139A16,16,0,0,0,97,123Z",
    style: {
      fill: "#e6eaed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.25,215a11.08,11.08,0,0,0-9.15,5A11.08,11.08,0,0,0,48,215a10.87,10.87,0,0,0-7.74,3.24A11.07,11.07,0,0,0,37,226.05c0,3.88,2.43,6.67,5,9.25l9.93,9.48a.82.82,0,0,0,1.37-.61V236.8a3.83,3.83,0,1,1,7.66,0v7.37a.81.81,0,0,0,.49.75.8.8,0,0,0,.88-.16l9.93-9.46c2.54-2.58,5-5.37,5-9.25A11.07,11.07,0,0,0,74,218.24,10.87,10.87,0,0,0,66.25,215ZM47,234.54a.71.71,0,0,1-.55.26.75.75,0,0,1-.49-.19c-3.16-2.88-4.77-5.89-4.77-8.94v0a8.84,8.84,0,0,1,3.63-6.93.72.72,0,0,1,1,.25.77.77,0,0,1-.22,1,7.3,7.3,0,0,0-2.94,5.65v0c0,2.6,1.44,5.23,4.28,7.8a.76.76,0,0,1,.25.53A.75.75,0,0,1,47,234.54ZM51.9,232a.73.73,0,0,1-.65.4.75.75,0,0,1-.36-.1,7.48,7.48,0,0,1-3.69-6.22v0a6.3,6.3,0,0,1,3.23-5.56.72.72,0,0,1,.75,0,.79.79,0,0,1,0,1.35,4.75,4.75,0,0,0-2.45,4.19,5.88,5.88,0,0,0,2.92,4.88.74.74,0,0,1,.36.47A.76.76,0,0,1,51.9,232Zm5.2-2a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,57.1,230Zm6.21,2.3a.74.74,0,0,1-.35.1.77.77,0,0,1-.74-.59.81.81,0,0,1,.38-.88,5.86,5.86,0,0,0,2.89-4.87A4.75,4.75,0,0,0,63,221.87a.78.78,0,0,1-.31-1.05.74.74,0,0,1,1-.33A6.31,6.31,0,0,1,67,226.05v0a7.56,7.56,0,0,1-3.69,6.25ZM73,225.67c0,3.05-1.61,6.06-4.78,8.94a.73.73,0,0,1-.49.19.74.74,0,0,1-.68-.49.76.76,0,0,1,.2-.83c2.84-2.58,4.28-5.21,4.28-7.8v0A7.27,7.27,0,0,0,68.59,220a.76.76,0,0,1-.22-1,.72.72,0,0,1,1-.25A8.81,8.81,0,0,1,73,225.64Z",
    style: {
      fill: "#c6002b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,329a8,8,0,1,0-8-8A8,8,0,0,0,57,329Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,137a3,3,0,1,0-3-3A3,3,0,0,0,57,137Z",
    style: {
      fill: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5,123.5h-79a16,16,0,0,0-16,16v181a16,16,0,0,0,16,16h79a16,16,0,0,0,16-16v-181A16,16,0,0,0,96.5,123.5Z",
    style: {
      fill: "none",
      stroke: "#4a4a4a",
      strokeWidth: 3
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesLockup);
export default __webpack_public_path__ + "static/media/devices-lockup.8e96c3dd4a1a3450cb6d8c128a402793.svg";
export { ForwardRef as ReactComponent };